module.exports = __webpack_public_path__ + "img/57.de92f18c.png";